import React from 'react';
import { IDocumentModalState } from '../modals/DocumentModal2';

type DocumentModalContextType = {
  onChange?: (field: string, value: any) => void;
  values?: IDocumentModalState;
};

const DocumentModalContext = React.createContext<DocumentModalContextType>({});
export default DocumentModalContext;
